import React from "react";
import { Award, Users, Target, TrendingUp } from "lucide-react";

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-white reveal">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-[#8B1538] font-semibold text-sm uppercase tracking-wider">About Crimson Inks</span>
              <div className="h-1 w-20 bg-[#8B1538] mt-2"></div>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Innovation Meets Excellence Since 2000
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Crimson Inks Private Limited, based in Kanpur, Uttar Pradesh, is a pioneering manufacturer and solutions provider in the printing industry. With over two decades of expertise, we specialize in advanced UV and LED curable coatings.
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Under the visionary leadership of <span className="font-semibold text-gray-900">Directors Chirag Jain & Prateek Jain</span>, we are committed to delivering cutting-edge coating technologies that enhance quality, efficiency, and sustainability across diverse printing applications.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="text-center p-6 bg-gradient-to-br from-red-50 to-white rounded-xl border border-red-100">
                <div className="text-4xl font-bold text-[#8B1538]">25+</div>
                <div className="text-gray-600 mt-2">Years Experience</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-red-50 to-white rounded-xl border border-red-100">
                <div className="text-4xl font-bold text-[#8B1538]">500+</div>
                <div className="text-gray-600 mt-2">Happy Clients</div>
              </div>
            </div>
          </div>

          {/* Right Content - Values */}
          <div className="space-y-4">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-red-100 p-3 rounded-lg">
                  <Target className="h-6 w-6 text-[#8B1538]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Innovation</h3>
                  <p className="text-gray-600">Pioneering advanced UV and LED curable coating technologies that set industry standards.</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-red-100 p-3 rounded-lg">
                  <img src="/quality-logo.png" alt="ISO 9001:2015" className="h-8 w-8" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Quality</h3>
                  <p className="text-gray-600">ISO 9001:2015 certified, ensuring the highest standards in every product we deliver.</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-red-100 p-3 rounded-lg">
                  <Users className="h-6 w-6 text-[#8B1538]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Reliability</h3>
                  <p className="text-gray-600">Trusted partner for printers and converters across India, China, and Singapore.</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-red-100 p-3 rounded-lg">
                  <TrendingUp className="h-6 w-6 text-[#8B1538]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Custom Solutions</h3>
                  <p className="text-gray-600">Tailored formulations designed to meet specific industrial requirements and applications.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
